module.exports = __webpack_public_path__ + "assets/img/5_1348_big.926d4947.jpg";